/**
 * Utilidad para obtener la URL base correcta según el entorno
 */

export const getBaseUrl = () => {
  if (typeof window === 'undefined') {
    // En entornos sin window (SSR/tests), devolvemos directamente producción
    return 'https://mundoxyz.com';
  }

  const origin = window.location.origin || '';

  // Si estamos en Capacitor (APK), siempre usar la URL de producción
  if (origin.startsWith('capacitor://')) {
    return 'https://mundoxyz.com';
  }

  try {
    const url = new URL(origin);
    const hostname = url.hostname || '';

    // Si el panel corre en localhost/127.0.0.1, los enlaces compartibles (QR, share)
    // deben apuntar al dominio público de producción.
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'https://mundoxyz.com';
    }

    // En producción web real, usar la URL actual
    return origin;
  } catch {
    // Fallback seguro: dominio público de producción
    return 'https://mundoxyz.com';
  }
};



export const getStoreUrl = (storeSlug) => {
  return `${getBaseUrl()}/store/${storeSlug}`;
};

export const getStoreQrUrl = (storeSlug) => {
  return `${getBaseUrl()}/store/${storeSlug}/qr`;
};

export const getProductUrl = (storeSlug, productId, referrerCode = null) => {
  const baseUrl = getStoreUrl(storeSlug);
  const params = new URLSearchParams();
  
  if (productId) {
    params.append('product', productId);
  }
  
  if (referrerCode) {
    params.append('ref', referrerCode);
  }
  
  const paramString = params.toString();
  return paramString ? `${baseUrl}?${paramString}` : baseUrl;
};

export const resolveImageUrl = (rawUrl) => {
  if (!rawUrl || typeof rawUrl !== 'string') return rawUrl;
  const trimmed = rawUrl.trim();
  if (!trimmed) return rawUrl;

  const normalizedSlashes = trimmed.replace(/\\/g, '/');
  const lowered = normalizedSlashes.toLowerCase();
  if (lowered.startsWith('data:') || lowered.startsWith('blob:')) return trimmed;
  if (lowered.startsWith('http://') || lowered.startsWith('https://')) return trimmed;

  let imgBase = '';
  if (typeof window !== 'undefined') {
    const origin = window.location.origin || '';
    if (origin.startsWith('capacitor://')) {
      imgBase = 'https://mundoxyz.com';
    } else {
      imgBase = origin;
    }
  } else {
    imgBase = 'https://mundoxyz.com';
  }

  if (lowered.startsWith('backend/uploads/')) {
    const rel = `/${normalizedSlashes.slice('backend/'.length)}`;
    return `${imgBase}${rel}`;
  }

  if (lowered.startsWith('/uploads/')) {
    return `${imgBase}${normalizedSlashes}`;
  }
  if (lowered.startsWith('uploads/')) {
    return `${imgBase}/${normalizedSlashes}`;
  }

  if (lowered.startsWith('/api/')) {
    return `${imgBase}${normalizedSlashes}`;
  }
  if (lowered.startsWith('api/')) {
    return `${imgBase}/${normalizedSlashes}`;
  }

  return normalizedSlashes;
};

const appendCacheBuster = (url, token) => {
  if (!url || typeof url !== 'string') return url;
  if (!token) return url;
  const t = String(token).trim();
  if (!t) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}v=${encodeURIComponent(t)}`;
};

export const resolveImageUrlBusted = (rawUrl, versionToken) => {
  const resolved = resolveImageUrl(rawUrl);
  if (!resolved || typeof resolved !== 'string') return resolved;
  const lowered = resolved.toLowerCase();
  if (lowered.startsWith('data:') || lowered.startsWith('blob:')) return resolved;
  if (lowered.includes('/uploads/') || lowered.includes('/api/store/product-image/')) {
    return appendCacheBuster(resolved, versionToken);
  }
  return resolved;
};
